"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLabel = exports.P = exports.pStyles = exports.LabelH3 = exports.StyledLabelH3 = exports.H3 = exports.StyledH3 = exports.h3Styles = exports.LabelH2 = exports.StyledLabelH2 = exports.H2 = exports.StyledH2 = exports.h2Styles = exports.LabelH1 = exports.StyledLabelH1 = exports.H1 = exports.h1Styles = exports.Span = exports.Title = exports.Label = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
var Label_1 = require("./Label");
Object.defineProperty(exports, "Label", { enumerable: true, get: function () { return Label_1.Label; } });
var Title_1 = require("./Title");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return Title_1.Title; } });
const styleType = (0, styled_components_1.css) `
  ${({ styleType }) => styleType === "primary" &&
    (0, styled_components_1.css) `
      ${exports.h1Styles};
    `}

  ${({ styleType }) => styleType === "secondary" &&
    (0, styled_components_1.css) `
      ${exports.h2Styles};
    `}

  ${({ styleType }) => styleType === "third" &&
    (0, styled_components_1.css) `
      ${exports.h3Styles};
    `}
`;
exports.Span = styled_components_1.default.span `
  color: ${({ theme, color = "primary" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }};
  font-weight: ${({ theme, fontWeight = "inherit" }) => theme.font[fontWeight]};
`;
exports.h1Styles = (0, styled_components_1.css) `
  font-family: 'Poppins' !important;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.space.L};
  ${base_ui_components_atoms__atoms_1.common};
  font-size: ${({ theme, fontSize = "XXXL" }) => { var _a; return (_a = theme.font[fontSize]) !== null && _a !== void 0 ? _a : fontSize; }};
  font-weight: ${({ theme, fontWeight = "bold" }) => theme.font[fontWeight]};
  line-height: normal;
  color: ${({ theme, color = "second" }) => theme.color[color]};

  span {
    color: ${({ theme, spanColor = "primary" }) => theme.color[spanColor]};
  };
`;
const StyledH1 = styled_components_1.default.h1 `
  ${styleType};
`;
const H1 = (_a) => {
    var { styleType = "primary", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    return react_1.default.createElement(StyledH1, Object.assign({ styleType: styleType }, rest), children);
};
exports.H1 = H1;
exports.StyledLabelH1 = styled_components_1.default.label `
  ${exports.h1Styles};
`;
const LabelH1 = (_a) => {
    var { styleType = "primary", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    return react_1.default.createElement(exports.StyledLabelH1, Object.assign({ styleType: styleType }, rest), children);
};
exports.LabelH1 = LabelH1;
exports.h2Styles = (0, styled_components_1.css) `
  font-family: 'Poppins' !important;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.space.M};
  ${base_ui_components_atoms__atoms_1.common};
  font-size: ${({ theme, fontSize = "XXL" }) => { var _a; return (_a = theme.font[fontSize]) !== null && _a !== void 0 ? _a : fontSize; }};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: normal;
  color: ${({ theme, color = "second" }) => theme.color[color]};
  display: flex;
  justify-content: ${({ textAlign = "flex-start" }) => textAlign};
  align-items: flex-end;

  span {
    font-size: ${({ theme }) => theme.font.L};
    line-height: ${({ theme }) => theme.font.L};
    color: ${({ theme }) => theme.color.third};
    font-weight: ${({ theme }) => theme.font.normal};
  }
`;
exports.StyledH2 = styled_components_1.default.h2 `
  ${styleType};
`;
const H2 = (_a) => {
    var { styleType = "secondary", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    return react_1.default.createElement(exports.StyledH2, Object.assign({ styleType: styleType }, rest), children);
};
exports.H2 = H2;
exports.StyledLabelH2 = styled_components_1.default.label `
  ${exports.h2Styles};
`;
const LabelH2 = (_a) => {
    var { styleType = "primary", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    return react_1.default.createElement(exports.StyledLabelH2, Object.assign({ styleType: styleType }, rest), children);
};
exports.LabelH2 = LabelH2;
exports.h3Styles = (0, styled_components_1.css) `
  font-family: 'Poppins' !important;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.space.S};
  ${base_ui_components_atoms__atoms_1.common};
  display: block;
  font-size: ${({ theme, fontSize = "L" }) => { var _a; return (_a = theme.font[fontSize]) !== null && _a !== void 0 ? _a : fontSize; }};
  font-weight: ${({ theme }) => theme.font.normal};
  line-height: normal;
  color: ${({ theme, color = "second" }) => theme.color[color]};
`;
exports.StyledH3 = styled_components_1.default.h3 `
  ${styleType};
`;
const H3 = (_a) => {
    var { styleType = "third", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    return react_1.default.createElement(exports.StyledH3, Object.assign({ styleType: styleType }, rest), children);
};
exports.H3 = H3;
exports.StyledLabelH3 = styled_components_1.default.label `
  ${exports.h3Styles};
`;
const LabelH3 = (_a) => {
    var { styleType = "primary", children } = _a, rest = __rest(_a, ["styleType", "children"]);
    // @ts-ignore
    return react_1.default.createElement(exports.StyledLabelH3, Object.assign({ styleType: styleType }, rest), children);
};
exports.LabelH3 = LabelH3;
exports.pStyles = (0, styled_components_1.css) `
  font-family: 'Poppins' !important;
  margin: 0;
  margin-bottom: ${({ theme }) => theme.space.S};
  ${base_ui_components_atoms__atoms_1.common};
  font-size: ${({ theme, fontSize = "L" }) => { var _a; return (_a = theme.font[fontSize]) !== null && _a !== void 0 ? _a : fontSize; }};
  color: ${({ theme, color = "second" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }};
  line-height: normal;
  text-align: ${({ textAlign }) => textAlign || "left"};
  max-width: ${({ maxWidth }) => maxWidth || "none"};
  white-space: ${({ whiteSpace }) => whiteSpace};
  text-overflow: ${({ textOverflow }) => textOverflow};
  overflow: ${({ overflow }) => overflow};
  font-weight: ${({ theme, fontWeight = "light" }) => theme.font[fontWeight]};

  span,
  b {
    font-weight: ${({ theme, fontWeight = "bold" }) => theme.font[fontWeight]};
  }

  button {
    background: none;
    padding: 0;
    border: none;
    color: ${({ theme }) => theme.color.primary};
  }
`;
exports.P = styled_components_1.default.p `
  ${exports.pStyles};

  ${({ small, fontSize = "M" }) => small &&
    (0, styled_components_1.css) `
      font-size: ${({ theme }) => theme.font[fontSize]};
    `}
`;
exports.RateLabel = styled_components_1.default.label `
  ${exports.h1Styles};
  display: block;
  margin: ${({ margin = "0" }) => margin};
  line-height: ${({ theme, fontSize = "XXXL" }) => theme.font[fontSize]};
  
  span {
    ${exports.h3Styles};
    line-height: ${({ theme }) => theme.font.L};
    margin: 0;
    display: inline-block;
  }
`;
//# sourceMappingURL=index.js.map